function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Regular/Location");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Regular/Location",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "map-pin",
  transform: "translate(2.500000, 1.000000)",
  stroke: "#80A1FE",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.8181818,5.40909091 C10.8181818,9.61616162 5.40909091,13.2222222 5.40909091,13.2222222 C5.40909091,13.2222222 0,9.61616162 0,5.40909091 C4.45151094e-08,2.42173252 2.42173252,8.06017354e-08 5.40909091,8.06017355e-08 C8.3964493,8.06017357e-08 10.8181818,2.42173252 10.8181818,5.40909091 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 5.40909091,
  cy: 5.40909091,
  r: 1.8030303
})));

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.ad160760.svg";
export { ForwardRef as ReactComponent };